export default "/apps/maps/img/marker-icon.png";